<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/template/point/conf/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">

          <el-form-item :label="$t('bieming')">
            <el-input v-model="yt.conditions.alias"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({equipmentId:yt.conditions.equipmentId,orderBy:'pointId'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
				<!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('GET','/web/template/point/conf/updateConfByEquipment?equipmentId=' + yt.conditions.equipmentId)">
          {{$t('更新')}}
        </el-button>
      </template>
				<!-- 操作插槽 -->
				<template #caozuo="scope">
					<el-row :gutter="10">
						<el-col :span="0.1">
							<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
						</el-col>
						<el-col :span="0.1">
							<el-button type="text" class="font-color-danger"
								@click="yt.remove(scope.row,'/web/template/point/delete')">{{$t('shanchu')}}
							</el-button>
						</el-col>
					</el-row>
				</template>
		</yi_curd_table>
			<!-- 新增/编辑弹框 -->
			<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
				:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

				<!-- 更新表单 -->
				<template v-if="yt.editObj.action == 'bianji'">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mubandianbianma')" required >
              <el-input disabled v-model="yt.editObj.point.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bieming')" required>
              <el-input v-model="yt.editObj.alias"></el-input>
            </el-form-item>
            <el-form-item :label="$t('danwei')">
              <el-input v-model="yt.editObj.unit"></el-input>
            </el-form-item>
            <el-form-item :label="$t('baoliuxiaoshuwei')">
              <el-input v-model="yt.editObj.prec"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xishu')">
              <el-input v-model="yt.editObj.factor"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/point/conf/update')"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
			</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		name: 'admin_data_equipment_template_point_conf',
		data() {
			return {
        templateSelect: false,
				columns: [{
          label: 'mubandianbianma',
          prop: 'point.code',
        },{
					label: 'bieming',
					prop: 'alias',
				}, {
					label: 'danwei',
					prop: 'unit',
				}, {
          label: 'baoliuxiaoshuwei',
          prop: 'prec',
        }, {
          label: 'xishu',
          prop: 'factor',
        }, {
          label: 'beizhu',
          prop: 'remark',
        }, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
          equipmentId: this.$attrs.equipmentId,
					orderBy:'pointId',
				}
				this.yt.get(1);
			}, 300)		
		},
		methods: {
			// 字典值新增
			 beforeAdd(params, url) {
				 params.equipmentId = this.$attrs.equipmentId
			 	return params
			 },

		
		}
	};
</script>


<style>
</style>
